import { ACCUControlForm } from "../../components/investor-dashboard";

const InvestorDashboardACCUControlPage = () => {
  return <ACCUControlForm />;
};

export default InvestorDashboardACCUControlPage;
